module.exports = __webpack_public_path__ + "static/media/13_l_topol_18.65_49.72.ee0a82ae.png";